export const LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_LOADING =
  "LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_LOADING";
export const LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_SUCCESS =
  "LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_SUCCESS";
export const LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_FAILED =
  "LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_FAILED";
export const LAMBDATEST_CLEAR_PLAYWRIGHT_TRACE_LOGS =
  "LAMBDATEST_CLEAR_PLAYWRIGHT_TRACE_LOGS";